module.exports = {"global":{"mode":"production","root":"https://api.etelconnections.com","version":"v2"}}


//////////////////
// WEBPACK FOOTER
// ./src/api/config.json
// module id = 206
// module chunks = 37